import React from 'react'

import AppLink from '../AppLink'
import { useRoutesContext } from '../RoutesContext'

import * as Styled from './styled'

interface Props {
  showAuthModal: boolean
  onSignInClick: () => void
  onRegisterClick: () => void
}

const NotLoggedIn: React.FunctionComponent<Props> = ({
  showAuthModal,
  onSignInClick,
  onRegisterClick,
}) => {
  const { toLogin, toSignup } = useRoutesContext()

  return (
    <Styled.LoginMessage>
      You must be logged in to view your account details. Please&nbsp;
      {showAuthModal ? (
        <Styled.AuthLink onClick={onSignInClick}>login</Styled.AuthLink>
      ) : (
        <AppLink route={toLogin()}>
          <Styled.AuthLink>login</Styled.AuthLink>
        </AppLink>
      )}
      &nbsp; or&nbsp;
      {showAuthModal ? (
        <Styled.AuthLink onClick={onRegisterClick}>register</Styled.AuthLink>
      ) : (
        <AppLink route={toSignup()}>
          <Styled.AuthLink>register</Styled.AuthLink>
        </AppLink>
      )}
      &nbsp; first.
    </Styled.LoginMessage>
  )
}

export default NotLoggedIn
